module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-sg/desktop-4fb76f381fd5836b2ffe55616a114f71.png";